<template>
  <div>
    <v-app-bar
      v-if="getbIncrustadoSuperior == false"
      flat
      clipped-right
      color="#FFF"
      class="cont-shadown-rounded mb-2 cont-barra-modulo"
      height="40px">
      <menu-principal
        :aMenu="itemsMenu"
        :nNivel="1"
      />
      <v-toolbar-title class="text-primary">{{ sTitleMenu }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn
        :to="'/DashBoard'"
        outlined small icon 
        color="primary" class="mx-1">
        <v-icon size="20px" class="btncolor--text mx-1">mdi-view-dashboard-outline</v-icon>
      </v-btn> -->
      <!-- <v-btn v-if="itemsProgress.length>0" outlined small icon class="mx-1"
        color="primary"
        @click="drawerRight = !drawerRight">
        <v-icon size="22px" class="btncolor--text mx-1" :class="{'rotate-icon':drawerRight}">mdi-menu-open</v-icon>
      </v-btn> -->
    </v-app-bar>
    <v-container>
      <!-- <dashConfig v-if="(/^\/Inicio\/[a-zA-Zá-źÁ-Ź0-9%]+$/.test($route.path))" :sIdModule="sIdModule"></dashConfig> -->
      <!-- <dashConfig v-if="!(/^\/Inicio\/.+\//.test($route.path))" :sIdModule="sIdModule"></dashConfig> -->
      <router-view name="config"></router-view>
      <Carousel v-if="getIdModule==17 && $route.path.toLowerCase() == '/inicio/sac' " />
    </v-container>
  </div>
</template>
<script>
import axiosServices from "@/services/axiosServices.js"
// import dashConfig from '@/components/DashConfig.vue'
import MenuPrincipal from '@/components/Menu.vue' 
import Carousel from '@/views/sac/Carousel.vue'
import { mapGetters } from 'vuex'

export default {
  name:"navconfig",
  props: {
    sIdModule: {
      type: Number || String,
    },
    sTitleMenu: {
      type: String,
    }
  },
  components: {
    // dashConfig,
    MenuPrincipal,
    Carousel
  },
  data() {
    return {
      drawerRight: false,
      itemsMenu: [],
      itemsProgress: [],
      sValueItems: 0,
      bMenuVer: false,
    }
  },
  created() {
    //se valida si en el local store se encuentra la variable y se asigna al menu
    const bIncrustadoSuperior = localStorage.bIncrustadoSuperior; 
    if(localStorage.bIncrustadoSuperior!=undefined&&localStorage.bIncrustadoSuperior!=null){
      this.$store.dispatch('savebIncrustadoSuperior', bIncrustadoSuperior.toString()=="true"?true:false);
    }
    this.getMenuModules(); //Menú lateral
  },
  updated() {
    const bIncrustadoSuperior = localStorage.bIncrustadoSuperior; 
    if(bIncrustadoSuperior !== null && bIncrustadoSuperior !== undefined){
      // validamos que el valor sea true en boolean
      this.$store.dispatch('savebIncrustadoSuperior', bIncrustadoSuperior.toString()=="true"?true:false);
    }
  }, 
  computed: {
    ...mapGetters(['getIdModule', 'getbIncrustadoSuperior'])
  },
  methods: {
    getMenuModules() {      
      if(!this.$store.state.login) return;
      if(!this.getbIncrustadoSuperior){
        this.itemsMenu=[];
        axiosServices.getConfiguration("/modulesMenu", true, `nIdModule=${this.getIdModule}&nIdPerfil=${this.$store.state.idPerfil}`)
        .then(aGetMenuModules => {
          this.itemsMenu = aGetMenuModules.aData;
        })
      }
    },
    getValue(oProgress) {
      let nTotalProgress = 0;
      let nCantItems = oProgress.length;
      oProgress.forEach(elemen => {
        if (elemen.complete == 1) {
          nTotalProgress += (100 / nCantItems);
        }
      });
      this.sValueItems = nTotalProgress;
    }
  },
  watch: {
    sIdModule(sNewValue, sOldValue) {
      if (sNewValue !== sOldValue) {
        this.getMenuModules();
      }
    },
    $route(sNewValue, sOldValue) {
      if (sNewValue !== sOldValue) {
        // if(!this.$route.matched.length >= 2){
          this.getMenuModules()
        // }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.titulo-avance{
  background: var(--v-primarydark-base);
  padding:5px;
}
.cont-barra-modulo{
  z-index: 3;
}
</style>